import { RawDestinationType as EdgeRawDestinationType } from '../../../../edge/destinations/interfaces/destination';
import { DESTINATION_TYPES } from '../../constants/destinationTypes';
import { CombinedDestinationType, RawDestinationType } from '../../interfaces/destinationType';

export function mergeDestinationTypes(
  standardList: RawDestinationType[],
  edgeList: EdgeRawDestinationType[]
) {
  const list = new Map<string, CombinedDestinationType>();

  standardList.forEach((item) => {
    list.set(item.dest_type, {
      type: item.dest_type,
      displayName: item.dest_type_display,
      logoUrl: item.dest_type_logo_url,
      darkModeLogoUrl: item.dest_type_dark_mode_logo_url,
      enterpriseNodeLogo: false,
      primaryColor: DESTINATION_TYPES[item.dest_type].primaryColor,
      darkModePrimaryColor: DESTINATION_TYPES[item.dest_type].darkModePrimaryColor,
      standardType: item,
      edgeType: undefined
    });
  });

  edgeList.forEach((item) => {
    const existingRef = list.get(item.type);

    if (existingRef) {
      list.set(item.type, {
        ...existingRef,
        edgeType: item
      });

      return;
    }

    list.set(item.type, {
      type: item.type,
      displayName: item.display_name,
      logoUrl: item.logo_url,
      darkModeLogoUrl: item.dark_mode_logo_url,
      enterpriseNodeLogo: true,
      primaryColor: undefined,
      darkModePrimaryColor: undefined,
      standardType: undefined,
      edgeType: item
    });
  });

  return [...list.values()];
}
